export var ApplicantType;
(function (ApplicantType) {
    ApplicantType["Borrower"] = "BORROWER";
    ApplicantType["BorrowerAndGuarantor"] = "BORROWER_AND_GUARANTOR";
    ApplicantType["Guarantor"] = "GUARANTOR";
})(ApplicantType || (ApplicantType = {}));
//# sourceMappingURL=ApplicantType.js.map